import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'underscore';

import { acBilet } from '../actions/acBilet'
import { acBiletTab } from '../actions/acBiletTab'

class RandomNumbers extends React.Component {

    constructor() {
        super();
        this.state = {
            randomNum: null
        };
    }
    selectBila(randomArr) {
        //primul sistem de la care se incepe in functie de nr de bile
        // var sistemMulti = [1, 1, 2, 2, 2, 3, 3, 4]

        var rundaVal = this.props.rundaSelectata
        var valBiletNou = {
            idRunda: rundaVal.id,
            roundUnique: rundaVal.round_unique,
            numereArr: randomArr,
            timeStart: rundaVal.timeStart,
            numeLot: this.props.activeLot.name_lot,
            gameType: this.props.activeLot.game_type,
            odds: this.props.activeLot.odds,
            miza: 0,
            currency: this.props.defaultVal.currency,
            // checked: [sistemMulti[randomArr.length - 1]],
            checked: [1],
            cotaTot: 0,
            castigEv: 0,
            sum: [],
            coteFixe: [],
            position: this.props.biletTab,
            valid: true,
            pariat: false,
            mesaj: '',
            future: 0,
            futureSuccess: 0,
            futureError: 0,
            futureErrorRounds: [],
            futureMessage: [this.props.multiLang.biletePariate.txt, this.props.multiLang.bileteEsuate.txt],
            nrFavorite: null
        }
        if (this.props.bilete === null) {
            if (this.props.rundaSelectata !== null) {
                this.props.acBilet(['biletNou', valBiletNou])
            }
        } else {
            var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            if (findBilet) {
                if (findBilet.round_unique === this.props.rundaSelectata.round_unique && this.props.activeLot.name_lot === findBilet.numeLot) {
                    var values = {
                        position: findBilet.position,
                        randomNumbers: randomArr,
                        odds: this.props.activeLot.odds
                    }
                    this.props.acBilet(['biletRandomNr', values])
                } else {
                    this.props.acBilet(['biletNouSamepoz', valBiletNou])
                }
            } else {
                this.props.acBilet(['biletNou', valBiletNou])
            }
        }
    }
    randomBile(number) {
        this.setState({ randomNum: number })
        let maxVal = parseInt(this.props.activeLot.nr_balls, 10)
        let initMaxVal = maxVal
        let arr, randomArr = []
        let val

        for (let i = 1; i <= number; i++) {
            // console.log(i)
            if (i === 1) {
                // val = _.random(1, maxVal--)
                val = Math.floor(Math.random() * maxVal--) + 1
            } else {
                arr = []
                for (let j = 1; j <= initMaxVal; j++) {
                    //arr = The array with all numbers left (without random values selection)
                    if (!randomArr.includes(j)) {
                        arr.push(j)
                    }
                }
                // val = arr[_.random(1, -)]
                val = arr[Math.floor(Math.random() * maxVal--)]
            }
            // console.log(val)
            // console.log(arr)
            randomArr.push(val)
        }
        this.selectBila(randomArr)
    }
    onDeleteAll(val) {
        var values = {
            position: val,
        }
        this.props.acBilet(['biletDelete', values])
    }
    refreshRandom() {
        if (this.state.randomNum) {
            this.randomBile(this.state.randomNum)
        }
    }
    render() {
        var bilet_current = _.findWhere(this.props.bilete, { position: this.props.biletTab })
        if (this.props.activeLot !== null) {
            var randomButtons = []
            let maxBile = this.props.activeLot.game_type.split('/')[0]

            if (maxBile > 8) {
                maxBile = 8
            }
            for (let j = 1; j <= maxBile; j++) {
                if (this.state.randomNum !== null && this.state.randomNum === j && bilet_current && bilet_current.numereArr.length === j) {
                    randomButtons.push(<button key={j} onClick={this.randomBile.bind(this, j)} className={j % 2 === 0 ? 'par active' : 'impar active'}>{j}</button>)
                } else {
                    randomButtons.push(<button key={j} className={j % 2 === 0 ? 'par' : 'impar'} onClick={this.randomBile.bind(this, j)}>{j}</button>)
                }
            }

            return (
                <div className="con-random-numbers">
                    <div>
                        <span>{this.props.multiLang.randomNb.txt}</span>
                        <div className='random-numbers'>
                            {randomButtons}
                        </div>
                        <div className="random-btns">
                            <button className="refresh" onClick={this.refreshRandom.bind(this)}>{this.props.multiLang.refresh.txt}</button>
                            <button className={'cancel-selection'} onClick={this.onDeleteAll.bind(this, this.props.biletTab)}>{this.props.multiLang.clear.txt}</button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div></div>
            )
        }
    }
}
function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        biletTab: state.biletTab,
        bilete: state.bilete,
        defaultVal: state.defaultVal,
        rundaSelectata: state.rundaSelectata,
        multiLang: state.multiLang
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acBilet: acBilet,
        acBiletTab: acBiletTab
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(RandomNumbers);